import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Stack, Switch, SwitchProps, Typography } from '@mui/material';

import { AppFormControl, AppFormControlProps } from 'components/AppFormControl';

interface Props extends Omit<AppFormControlProps, 'children'> {
  checked: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
  componentProps?: SwitchProps;
}

export const AppSwitchForm: FC<Props> = ({
  label,
  checked,
  onChange,
  disabled,
  componentProps,
  ...formControlProps
}) => {
  const { t } = useTranslation();

  return (
    <AppFormControl label={label} {...formControlProps} hideFormLabel>
      <Stack direction="row" alignItems="center">
        <Typography fontWeight="bold">
          {label}
          {formControlProps.varies && (
            <Typography component="span" color="warning.main" fontWeight={100}>
              {` (${t('varies')})`}
            </Typography>
          )}
        </Typography>
        <Stack flex={1} />
        <Switch
          {...componentProps}
          checked={checked}
          onChange={(_, c) => onChange(c)}
          disabled={disabled}
        />
      </Stack>
    </AppFormControl>
  );
};
